;(function () {
  'use strict'

  angular.module('deskfy.core').controller('TableColumnRowUserStatusController', tableColumnRowUserStatusController)

  /* @ngInject */
  function tableColumnRowUserStatusController ($rootScope, $scope, $translate, Utils) {
    $scope.getUserRemovedToolbarText = function () {
      const dateOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }
      const locale = $rootScope.oUser.locale
      const formattedData = $scope.removedAt ? Utils.formatDate($scope.removedAt, locale, dateOptions) : ' - '
      return $translate.instant('userRemovedAt', { removedAt: formattedData })
    }
  }
})()
